import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ListBulletedPronounced = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="4" cy="6" r="3" fill={color} />
        <path opacity="0.6" d="M9.5 4L14.5 4" stroke={color} strokeLinecap="round" />
        <path opacity="0.6" d="M9.5 8H13.5" stroke={color} strokeLinecap="round" />
        <path opacity="0.6" d="M9.5 12H14.5" stroke={color} strokeLinecap="round" />
      </svg>
    )
  },
)

export default ListBulletedPronounced
